/**
 * Fetches the *entire* set of pending adoption transfers (not just one page).
 *
 * The Devices page splits pending adoptions into two sections — recent
 * "Pending Transfers" and "Stalled Transfers" (older than N days) — and
 * paginates each client-side. That split can only be done accurately if we
 * hold the full list, so this hook drains every server page up front rather
 * than paging on demand like `useRescueDevices`.
 *
 * It's a thin wrapper over the generic `useAllRescueDevices` drain (fixed to the
 * PENDING_ADOPTIONS filter, never skipped) so the drain/transition logic lives
 * in one place.
 */

import useAllRescueDevices from './useAllRescueDevices';
import type { Device } from '../lib/types';

export interface UseAllPendingAdoptionsResult {
  /** Every pending adoption transfer matching the current search. */
  devices: Device[];
  loading: boolean;
  error: Error | undefined;
  refetch: () => void;
}

export default function useAllPendingAdoptions(
  searchQuery: string,
  resellerName: string,
): UseAllPendingAdoptionsResult {
  const { devices, loading, error, refetch } = useAllRescueDevices('PENDING_ADOPTIONS', searchQuery, resellerName);
  return { devices, loading, error, refetch };
}
